import React from 'react';
import cx from 'classnames';

export const getNameInitials = (name) => {
  if (!name || !name.length) return "";
  const nameSplit = name.split(" ");
  const initials =
    nameSplit.length == 1 ? nameSplit[0].substring(0, 2) : nameSplit[0][0] + nameSplit[1][0];
  return initials.toUpperCase();
};

export const getPredefinedColor = (uuid) => {
  if (!uuid || !uuid.length) return;
  const colors = ["#80deea", "#9fa7df", "#aed581", "#ce93d8", "#ef9a9a", "#ffab91", "#ffe082"];
  const sum = uuid
    .split("")
    .map((c) => c.charCodeAt(0))
    .reduce((a, b) => a + b);
  return colors[sum % colors.length];
};

const getTime = (timestamp) => {
  const ts = String(timestamp);
  const date = new Date(parseInt(ts) / 10000);
  return `${date.toLocaleTimeString([], { timeStyle: "short" })} - ${date.toLocaleDateString()}`
};

export function channelRender(props) {

  const { channel, switchChannel, currentChannel, unreadCount } = props;

  const channelActive = channel.id === currentChannel;
  const activeClass = channelActive ? "pn-channel--active" : "";

  return (
    <div
      key={channel.id}
      className={`pn-channel ${activeClass}`}
      onClick={() => switchChannel(channel)}
    >
      <div className="pn-channel__title flex justify-between items-center">
        <p className="pn-channel__name">{channel.name || channel.id}</p>
        <div className={cx("text-xs p-1 px-2 rounded-full", { ['bg-green-100 text-green-800']: unreadCount > 0 })}>{unreadCount}</div>
      </div>
    </div>
  );
}

export function messageRenderer({ message: envelope, user, time, isOwn, editedText }, deleteMessage, is_supervisor) {

  const uuid = envelope.uuid

  return (
    <>
      <div className="pn-msg__avatar" style={{ backgroundColor: getPredefinedColor(uuid) }}>
        {getNameInitials(user?.name || uuid)}
      </div>

      <div className="pn-msg__main">
        <div className="pn-msg__content">
          <div className="pn-msg__title">
            <span className="pn-msg__author">{user?.name || uuid}</span>
            <span className="pn-msg__time">{getTime(envelope.timetoken)}</span>
            {is_supervisor && <span className="pn-msg__delete" onClick={() => deleteMessage(envelope.timetoken)}>Elimina</span>}
          </div>
          <div className="pn-msg__bubble">{envelope?.message.text}</div>
        </div>
      </div>
    </>
  );

}
